import { observer } from 'mobx-react-lite'
import { type TeamMembersViewModel } from '@/features/iam/teams/TeamMembersViewModel'
import { Id } from '@/infra/id'
import { MembersTable } from '@/features/iam/teams/components/MembersTable'

export interface MembersTableContainerProps {
  vm: TeamMembersViewModel
}

export const MembersTableContainer = observer(function MembersTableContainer({
  vm,
}: MembersTableContainerProps) {
  return (
    <MembersTable
      rows={vm.filtered.map((teamMember) => ({
        id: Id.assert(teamMember.member.user.id),
        avatar: {
          avatar: teamMember.member.avatar,
          avatarFallback: teamMember.member.avatarFallback,
          displayName: teamMember.member.displayName,
        },
        displayName: teamMember.member.displayName,
        email: teamMember.member.email,
        roleName: teamMember.teamRole.name,
        dateCreated: teamMember.dateCreated,
        onChangeRole: (newRoleId) =>
          vm.changeTeamMemberRole(teamMember, newRoleId),
        onRemove: () => vm.removeTeamMember(teamMember),
      }))}
      teamRoles={vm.teamRoles.map((role) => ({
        id: Id.assert(role.id),
        name: role.name,
        description: role.description,
      }))}
      canManageMember={vm.canManageTeamMember}
      currentSort={vm.sortField}
      currentSortOrder={vm.sortOrder}
      onSort={vm.setSort}
    />
  )
})
